import store from '@/packages/vuex'
import { Middleware } from '@/app/router'

export default new Middleware('SessionKey', ({ to, next, router }) => {
	// The password challenge passes its session as in-memory route params (not in
	// the path); the MFA challenge keeps it in transient Vuex state.
	if (to.name === 'Auth:MfaChallenge') {
		if (!store.getters['Auth/mfaChallenge']?.sessionKey) {
			return router.push({
				name: 'Auth:Login'
			})
		}
		return next()
	}

	if (!to.params.sessionKey) {
		return router.push({
			name: 'Auth:Login'
		})
	}

	return next()
})
